import { render, staticRenderFns } from "./PhotoItem.vue?vue&type=template&id=072dbcb2&"
import script from "./PhotoItem.vue?vue&type=script&lang=js&"
export * from "./PhotoItem.vue?vue&type=script&lang=js&"
import style0 from "./PhotoItem.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports